import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ScrollableList, ScrollableListVariant, ScrollDirection } from '@as/cotopaxi';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { makeGetQuickLinks } from '../../../redux/lister/selectors/ListerSelector';
import { generateTestId } from '../../../util/TestUtil';
import { QuickFilterItem } from './QuickFilterItem';
const TEST_ID = 'quick-filters';
/**
 * @deprecated
 */
export const QuickFilters = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const quickLinks = useSelector(makeGetQuickLinks());
    if (!(quickLinks && quickLinks.length > 0)) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(TextAlpha, { as: "span", strong: true, testId: generateTestId({ testId: TEST_ID, suffix: 'title' }), children: t('product.lister.quickFilters.title') }), _jsx(Box, { paddingBlockStart: "4", testId: generateTestId({ testId: TEST_ID, suffix: 'container' }), children: _jsxs(ScrollableList, { direction: ScrollDirection.HORIZONTAL, variant: ScrollableListVariant.GRADIENT, touchOnly: true, dataAnalyticsBannerid: "product-lister-quicklinks", children: [' ', quickLinks.map(quickLink => (_jsx(QuickFilterItem, { quickLink: quickLink }, `quickLink_${quickLink.linkName}`)))] }) })] }));
};
